interface ValidationItem {
    id: number;
    operation_id: string;
    assignor: string;
    amount: number;
    amount_payed: number;
    balance: number;
    percentage_payed: number;
    percentage_validated: number;
    total_titulos: number;
    total_payer: number;
    status: string;
    detail: string[];
    observation: string;
}

let validationData: ValidationItem[] = [];
let tagColors: Record<string, string> = {};

export const getValidationData = (): ValidationItem[] => {
    return validationData;
};

export const updateValidationItem = (id: number, updates: Partial<ValidationItem>): void => {
    const index = validationData.findIndex(item => item.id === id);
    if (index !== -1) {
        validationData[index] = { ...validationData[index], ...updates };
    }
};

export const getTagColor = (tag: string): string => {
    return tagColors[tag] || 'blue';
};

export const setTagColor = (tag: string, color: string): void => {
    tagColors[tag] = color;
};
